export default function XML_XLink() {
  return (
    <div>
      <h1>XML_XLink</h1>
      <p>This is the XML_XLink component.</p>
    </div>
  );
}